import {
  PublicClientApplication,
  InteractionRequiredAuthError
} from "@azure/msal-browser";



export const msalConfig = {


  auth: {

    clientId:
      process.env.REACT_APP_SSO_CLIENT_ID,


    authority:
      process.env.REACT_APP_SSO_Authorities,


    knownAuthorities: [

      "aaysb2c.b2clogin.com"

    ],


    redirectUri:
      window.location.origin,


    postLogoutRedirectUri:
      window.location.origin

  },



  cache: {

    cacheLocation:
      "localStorage",


    storeAuthStateInCookie:
      false

  }


};





export const loginRequest = {


  scopes:[

    "api://e438e517-dbd1-4e8e-a01b-df08540c0276/access_as_user"

  ]

};






export const msalInstance =
new PublicClientApplication(
  msalConfig
);






export const getToken = async()=>{


const accounts =
msalInstance.getAllAccounts();



if(accounts.length === 0){

throw new Error(
"No accounts found"
);

}



try{


const response =
await msalInstance.acquireTokenSilent({

account:accounts[0],

scopes:loginRequest.scopes

});


return response.accessToken;



}

catch(error){


if(
error instanceof InteractionRequiredAuthError
){


const response =
await msalInstance.acquireTokenPopup(
loginRequest
);


return response.accessToken;


}



throw error;


}



};